import { render, staticRenderFns } from "./contract-history-timeline-item.component.vue?vue&type=template&id=2ebda6da&"
import script from "./contract-history-timeline-item.component.vue?vue&type=script&lang=ts&"
export * from "./contract-history-timeline-item.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimelineItem})
